import React, { useEffect, useState } from "react";
import { Container, Image, Nav, Navbar } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import "../App.css";

const navItems = [
  { label: "Home", to: "/", end: true },
  { label: "About", to: "/about" },
  { label: "Products", to: "/category" },
  { label: "News", to: "/news" },
];

const NavigationBar = () => {
  const [expanded, setExpanded] = useState(false);
  const { pathname } = useLocation();

  const isNavItemActive = (item) => {
    if (item.end) {
      return pathname === item.to;
    }

    if (item.to === "/category") {
      return pathname === "/category" || pathname.startsWith("/category/");
    }

    if (item.to === "/news") {
      return pathname === "/news" || pathname.startsWith("/news/");
    }

    return pathname === item.to;
  };

  const closeNavbarAfterNavigation = () => {
    setExpanded(false);
    window.setTimeout(() => setExpanded(false), 0);
  };

  useEffect(() => {
    closeNavbarAfterNavigation();
  }, [pathname]);

  return (
    <Navbar
      expand="lg"
      sticky="top"
      expanded={expanded}
      onToggle={setExpanded}
      collapseOnSelect
      className={`site-navbar bg-white border-bottom shadow-sm py-2 ${
        expanded ? "site-navbar--open" : "site-navbar--closed"
      }`}
    >
      <Container>
        <Navbar.Brand
          as={Link}
          to="/"
          onClick={closeNavbarAfterNavigation}
          className="d-inline-flex align-items-center p-0"
        >
          <Image
            src="/assets/logo.png"
            alt="PT Bintang Anugerah Sukses"
            className="site-navbar__logo"
          />
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="site-navbar-nav"
          aria-label="Toggle navigation"
          className="rounded-3"
        />

        <Navbar.Collapse id="site-navbar-nav">
          <Nav
            className="ms-auto align-items-lg-center gap-lg-1 pt-3 pt-lg-0"
            onClickCapture={closeNavbarAfterNavigation}
            onSelect={closeNavbarAfterNavigation}
          >
            {navItems.map((item) => (
              <Nav.Link
                key={item.to}
                eventKey={item.to}
                as={Link}
                to={item.to}
                onClick={closeNavbarAfterNavigation}
                aria-current={isNavItemActive(item) ? "page" : undefined}
                className={`site-nav-link rounded-3 fw-bold px-3 py-2 ${
                  isNavItemActive(item) ? "active" : ""
                }`}
              >
                {item.label}
              </Nav.Link>
            ))}
            <Nav.Link
              eventKey="/contact"
              as={Link}
              to="/contact"
              onClick={closeNavbarAfterNavigation}
              aria-current={pathname === "/contact" ? "page" : undefined}
              className={`site-navbar__cta rounded-3 fw-bold px-3 py-2 text-center ${
                pathname === "/contact" ? "active" : ""
              }`}
            >
              Contact Sales
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavigationBar;
